module.exports = __webpack_public_path__ + "static/media/lst_img_01.f5d72056.png";